export default "__VITE_ASSET__cdc2ac6a__"